import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import Page from '../../@sprinx/react-web/Page';
import CataloguePageList from './components/CataloguePageList';
import CataloguePageListBreadcrumbs from './components/CataloguePageListBreadcrumbs';
import CataloguePageListHeadline from './components/CataloguePageListHeadline';
import CataloguePageSubCategories from './components/CataloguePageSubCategories';
import CataloguePageMainFilter from './components/CataloguePageMainFilter';

export type CataloguePageLayoutProps = StandardDivProps<CataloguePageLayoutClassKey>;

export type CataloguePageLayoutClassKey = 'root' | 'content' | 'mainFilter' | 'catalogueList';

const themeSettings = { name: 'CataloguePageLayout' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<CataloguePageLayoutClassKey, {}>({
      root: {},
      content: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        paddingTop: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
          flexDirection: 'row',
        },
      },
      mainFilter: {
        [theme.breakpoints.up('md')]: {
          flexShrink: 0,
          width: '260px', // same as CataloguePageSubCategories -> subCategory
        },
      },
      catalogueList: {
        flexGrow: 1,
      },
    }),
  themeSettings,
);

const CataloguePageLayout = React.forwardRef<HTMLDivElement, CataloguePageLayoutProps>(
  ({ className, classes: pClasses, ...rest }, ref) => {
    const classes = useStyles({ classes: pClasses });

    return (
      <Page
        ref={ref}
        className={clsx(classes.root, className)}
        pageTitle='Všechny produkty'
        breadcrumbs={<CataloguePageListBreadcrumbs />}
        {...rest}
      >
        <CataloguePageListHeadline />
        <CataloguePageSubCategories />
        <div className={classes.content}>
          <CataloguePageMainFilter className={classes.mainFilter} />
          <CataloguePageList className={classes.catalogueList} />
        </div>
      </Page>
    );
  },
);

CataloguePageLayout.displayName = 'CataloguePageLayout';

export default withThemeProps(themeSettings)(CataloguePageLayout);
